var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSsyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#F8DD84;stroke-width:130;stroke-miterlimit:10;}\n\t.st1{fill:#394251;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2000.06,
    cy: 2000.08,
    r: 1904.58
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2784.01,1206.23c-61.42,0-200.29-168.24-413.93-168.24c-478.02,0-1241.8,769.11-969.4,769.11 c122.84,0,403.25-181.6,841.22-181.6c574.16,0,654.28,280.41,654.28,488.71c0,742.41-865.25,1271.17-1386,1271.17 c-173.58,0-462-160.23-462-478.03c0-170.91,170.91-141.54,170.91-5.34c0,122.84,157.56,154.89,237.68,154.89 c320.46,0,985.42-480.7,985.42-924c0-197.62-32.05-360.52-218.98-360.52c-429.96,0-763.77,235.01-835.88,235.01 c-141.54,0-288.42-144.21-288.42-259.04c0-427.28,809.17-1134.98,1327.25-1134.98C2786.69,613.37,2917.54,1206.23,2784.01,1206.23z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsyLogo);
export default __webpack_public_path__ + "static/media/ssy-logo.fc41cbb5f5d40301ab331320bcfe4c81.svg";
export { ForwardRef as ReactComponent };